/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VINCheckerMeta
 */
export interface VINCheckerMeta {
    /**
     * 
     * @type {string}
     * @memberof VINCheckerMeta
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VINCheckerMeta
     */
    active: boolean;
}

export function VINCheckerMetaFromJSON(json: any): VINCheckerMeta {
    return VINCheckerMetaFromJSONTyped(json, false);
}

export function VINCheckerMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): VINCheckerMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'active': json['active'],
    };
}

export function VINCheckerMetaToJSON(value?: VINCheckerMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'active': value.active,
    };
}


